/**
 * Tiny module-level channel for "please focus node X" requests from
 * outside the Canvas component tree (e.g. the Toolbar issues popover).
 *
 * Canvas registers a handler on mount; anyone can call focusCanvasNode
 * and the canvas pans + zooms to the node. Keeping this out of the
 * editorStore so the store doesn't need to hold non-serializable fns.
 */

type FocusHandler = (nodeId: string) => void;

let handler: FocusHandler | null = null;

export function registerCanvasFocus(fn: FocusHandler | null): void {
  handler = fn;
}

export function focusCanvasNode(nodeId: string): void {
  handler?.(nodeId);
}
